const productDownloadElement = document.querySelector("[data-js='product-download']");

class ProductDownload {
  constructor(node) {
    this.element = node;
    this.languageSelectWrapper = this.element.querySelector(".js-product-download-language-select-wrapper");
    this.countrySelect = this.element.querySelector(".js-product-download-country-select");
    this.languageSelect = this.element.querySelector(".js-product-download-language-select");

    this.availableLanguages = [];
    this.selectTagsArray = [];

    this.initialize();
  }

  initialize() {
    this.countrySelect.addEventListener("available-languages-updated", (e) => {
      this.availableLanguages = e.detail.split(",");

      this.updateDownloadLink();
    });
  }

  updateDownloadLink() {
    const defaultLanguage = this.availableLanguages[0];

    const languageSelectInstance = window.Beyuna.objects["custom-select-with-link-change"].language;
    const defaultLanguageInput = languageSelectInstance.dropdownElement.querySelector(`input[id='${defaultLanguage}']`);

    languageSelectInstance.updateAvailableOptions(this.availableLanguages);

    defaultLanguageInput.checked = true;
    languageSelectInstance.updateHtml(defaultLanguage, defaultLanguageInput.closest(".custom-radio").querySelector(".js-select-value").innerHTML);

    languageSelectInstance.updateLink(defaultLanguageInput);
  }
}

if (productDownloadElement) {
  new ProductDownload(productDownloadElement);
}
